export type CatalogViewMode = 'list' | 'map';
export const CATALOG_DESKTOP_VIEW_MODE_DEFAULT: CatalogViewMode = 'list';
